<script setup>
import { watch } from "vue";
import { useDraggableModal } from "@/composables/useDraggableModal";

const props = defineProps({
  show: { type: Boolean, default: false },
});

const emit = defineEmits(["close"]);

// 🔹 NOVO: arrastar o modal pelo título (não há cabeçalho próprio aqui).
// Este componente não desmonta entre aberturas (só alterna `show`), então
// recentraliza ao reabrir para a posição não persistir.
const {
  panelRef,
  panelStyle,
  isDragging,
  isDraggable,
  onHandlePointerDown,
  resetPosition,
} = useDraggableModal();

watch(
  () => props.show,
  (val) => {
    if (val) resetPosition();
  }
);

function closeModal() {
  emit("close");
}
</script>

<template>
  <div
    v-if="show"
    class="fixed inset-0 z-[9998] flex items-center justify-center bg-black/20"
    @click.self="closeModal"
  >
    <div
      ref="panelRef"
      :style="panelStyle"
      class="bg-surface rounded-lg p-4 max-w-md w-full shadow-lg max-h-[80vh] overflow-y-auto"
    >
      <h2
        class="text-xl font-semibold mb-3"
        :class="{
 'cursor-move select-none touch-none': isDraggable,
          'cursor-grabbing': isDragging,
        }"
        @pointerdown="onHandlePointerDown"
      >
        Sobre a seção de textos
      </h2>

      <p
        class="text-sm leading-relaxed text-gray-800 mb-3"
      >
        Nesta página você pode visualizar, editar e organizar os textos que você
        criou ou que foram compartilhados com você por outros usuários.
      </p>

      <ul
        class="list-disc pl-5 text-sm text-gray-700 space-y-1.5 mb-3"
      >
        <li>
          Use o campo de busca para localizar textos rapidamente pelo título,
          subtítulo, autor...
        </li>
        <li>
          Abra o menu de ações para editar, visualizar ou excluir um texto.
        </li>
        <li>
          Marque múltiplos textos para realizar exclusões em lote rapidamente.
        </li>
        <li>
          Clique em “Adicionar Texto” para cadastrar um novo conteúdo.
        </li>
        <li>
          Clique sobre qualquer linha da tabela para ver detalhes completos.
        </li>
      </ul>

      <div class="mt-2 text-right">
        <button
          @click="closeModal"
          class="px-3 py-1.5 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700 transition"
        >
          Fechar
        </button>
      </div>
    </div>
  </div>
</template>


